/* eslint-disable no-prototype-builtins, no-param-reassign */

import { ApolloLink } from '@apollo/client';
import { Observable } from 'rxjs/Observable';

import get from 'lodash.get';
import { APP_LANGUAGES } from '../../../config/client.config';

export default class SetUserParamsLink extends ApolloLink {
  cache = null;

  defaultVariables = {};

  constructor({ cache, history }) {
    super();
    this.cache = cache;
    this.history = history;
  }

  request(operation, forward) {
    const languageSegment = this.history.location.pathname.split('/')[1];

    const language = APP_LANGUAGES.includes(languageSegment)
      ? languageSegment
      : null;

    const variables = {
      ...this.defaultVariables,
      language,
    };

    get(operation, 'query.definitions', []).forEach((definition) => {
      get(definition, 'variableDefinitions', []).forEach(
        (variableDefinition) => {
          const variableName = get(variableDefinition, 'variable.name.value');

          Object.keys(variables).forEach((key) => {
            if (
              variableName === key &&
              variables[key] !== undefined &&
              variables[key] !== null &&
              (operation.variables[key] === undefined ||
                operation.variables[key] === null)
            ) {
              operation.variables[key] = variables[key];
            }
          });
        }
      );
    });

    const subscriber = forward(operation);

    return new Observable((observer) => {
      const subscription = subscriber.subscribe({
        next: (result) => {
          if (
            result.data &&
            result.data.user &&
            result.data.user.language !== undefined &&
            result.data.user.language !== null
          ) {
            this.defaultVariables.language = result.data.user.language;
          }
          if (
            result.data &&
            result.data.user &&
            result.data.user.testmode !== undefined &&
            result.data.user.testmode !== null
          ) {
            this.defaultVariables.testmode = result.data.user.testmode;
          }
          if (
            result.data &&
            result.data.user &&
            result.data.user.cart &&
            result.data.user.cart.id !== undefined &&
            result.data.user.cart.id !== null
          ) {
            this.defaultVariables.cartId = result.data.user.cart.id;
          }

          return observer.next(result);
        },
        error: (error) => observer.error(error),
        complete: (result) => observer.complete(result),
      });

      return () => {
        if (subscription) subscription.unsubscribe();
      };
    });
  }
}
